import { render, staticRenderFns } from "./Notebook.vue?vue&type=template&id=fd7084ce&scoped=true&"
import script from "./Notebook.vue?vue&type=script&lang=js&"
export * from "./Notebook.vue?vue&type=script&lang=js&"
import style0 from "./Notebook.vue?vue&type=style&index=0&id=fd7084ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7084ce",
  null
  
)

component.options.__file = "Notebook.vue"
export default component.exports